import React, { useContext } from 'react';

import PropTypes from 'prop-types';

import { ForecasterContext } from '../../../context';

import { useBarGraphData, useLegends } from './hooks';
import View from './view';

const BarGraphProvider = React.memo((props) => {
	const {
		className,

		type,
		category,
		tag,

		dates,
		types = [type],

		showYAxis,
		showLines,
		showLegends,

		render,
	} = props;

	const { onAction } = useContext(ForecasterContext);

	const { labels, title, max, min } = useBarGraphData({
		type,
		dates,
		category,
		tag,
		types,
	});

	const legends = useLegends({ type, category, tag, types, dates });

	return (
		<View
			className={className}
			onAction={onAction}
			types={types}
			type={type}
			category={category}
			tag={tag}
			dates={dates}
			labels={labels}
			title={title}
			max={max}
			min={min}
			showYAxis={showYAxis}
			showLines={showLines}
			showLegends={showLegends}
			legends={legends}
			render={render}
		/>
	);
});

BarGraphProvider.displayName = 'BarGraphProvider';

BarGraphProvider.propTypes = {
	className: PropTypes.string,

	dates: PropTypes.arrayOf(PropTypes.string),
	types: PropTypes.arrayOf(PropTypes.string),

	onAction: PropTypes.func,

	type: PropTypes.string,
	category: PropTypes.string,
	tag: PropTypes.string,

	showYAxis: PropTypes.bool,
	showLines: PropTypes.bool,
	showLegends: PropTypes.bool,

	render: PropTypes.func,
};

export default BarGraphProvider;
